import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import React from "react";
import { XBRimg, XbrWhite } from "../../../assets/index.js";

const TokenSelection = ({
  tokens,
  dropdownRef,
  setIsOpen,
  isOpen,
  selectedToken,
  swapTokens,
  handleTokenChange,
  selectedToken2,
  newMax,
  sendValue,
  newOnChangeSwapInputs,
  paletteMode,
  isSendCard = false,
  isIncreaseBalance = false,
}) => {
  return (
    <div>
      <form className="w-full relative">
        <label className="sr-only" htmlFor="token-input">
          Enter your number
        </label>
        <input
          id="token-input"
          className={`w-full h-[46px]  pl-4 md:h-16 md:pl-6 
            dark:placeholder:text-lightWhite  
          ${
            paletteMode === "light"
              ? "bg-lightBlue placeholder:text-lightBlack"
              : "bg-darkButBg placeholder:text-lightWhite text-white"
          }  
        text-[14px] md:leading-6 md:text-[16px]  uppercase 
        text-black dark:text-white  rounded-lg font-light focus:outline-none`}
          type="text"
          autoComplete="off"
          placeholder={`00.00 ${selectedToken.name}`}
          onWheel={(e) => e.preventDefault()}
          onChange={(event) => {
            let inputValue = event.target.value;

            inputValue = inputValue.replace(/[^0-9.]/g, "");

            inputValue = inputValue.replace(/^([^.]*\.[^.]*)\./g, "$1");

            if (inputValue.startsWith("0") && !inputValue.startsWith("0.")) {
              inputValue = inputValue.replace(/^0+/, "0");
            }

            inputValue = inputValue.slice(0, 18);

            newOnChangeSwapInputs(
              inputValue,
              selectedToken.name,
              1,
              selectedToken2.name
            );
          }}
          value={sendValue}
        />
        <div className="flex gap-1 md:gap-2 absolute top-0 right-2 h-full items-center">
          {isSendCard && (
            <button
              type="button"
              className={`h-[30px] md:h-10 px-4 text-black 
                text-xs md:text-sm font-medium leading-[18px] md:leading-[21px] 
                uppercase flex items-center justify-center border border-deepBlue 
                rounded-lg  ${
                  paletteMode === "light"
                    ? "bg-white"
                    : "bg-darkCardBg text-white"
                }
                shadow-maxButtonShadow `}
              onClick={() => newMax(selectedToken.name, 1)}
            >
              Max
            </button>
          )}
          <div className="relative" ref={dropdownRef}>
            <button
              type={"button"}
              disabled={isIncreaseBalance}
              onClick={() => setIsOpen(!isOpen)}
              className={`h-[30px] md:h-10 justify-between ${
                isIncreaseBalance && "md:min-w-[106px] justify-сenter"
              } 
              ${paletteMode === "light" ? "bg-white" : "bg-darkCardBg"}
              flex items-center text-black  px-2 md:px-4 py-3  hover:bg-[#F6F9FF] active:bg-[#D8E2FF]  transition-colors duration-300 dark:bg-darkCardBg dark:hover:!bg-[#3C3A66] dark:text-white rounded-lg shadow-selectionShadow gap-2`}
            >
              <div className="flex items-center justify-center md:gap-2">
                <img
                  src={
                    selectedToken.name === "XBR"
                      ? paletteMode === "light"
                        ? XbrWhite
                        : XBRimg
                      : selectedToken.image
                  }
                  alt={selectedToken.name}
                  className="w-[20px] h-[20px] md:w-7 md:h-7 object-cover"
                />
                <span
                  className={`hidden md:block ${
                    paletteMode === "light" ? "text-[#000]" : "text-[#fff]"
                  } text-sm font-medium leading-[21px]`}
                >
                  {selectedToken.name}
                </span>
              </div>
              {!isIncreaseBalance &&
                (isOpen ? (
                  <ChevronUpIcon className="w-[14px] h-[14px] md:w-5 md:h-5 fill-black dark:fill-white" />
                ) : (
                  <ChevronDownIcon className="w-[14px] h-[14px] md:w-5 md:h-5 fill-black dark:fill-white" />
                ))}
            </button>
            {isOpen && (
              <div
                className={
                  "absolute w-full mt-1 shadow-selectionShadow bg-white border border-gray-300 dark:bg-darkCardBg rounded-lg z-50"
                }
              >
                {tokens.map((currency) => (
                  <div
                    key={currency.id}
                    className={
                      "px-1 md:px-4 rounded-[4px] py-1 hover:bg-[#F6F9FF] active:bg-[#D8E2FF] dark:hover:!bg-[#3C3A66] transition-colors duration-300 flex items-center gap-1 md:gap-2 cursor-pointer  dark:hover:bg-darkButBg"
                    }
                    onClick={() => {
                      if (currency.id === selectedToken2.id) {
                        swapTokens(1);
                      } else {
                        handleTokenChange(currency, true);
                      }
                      setIsOpen(false);
                    }}
                  >
                    <img
                      src={currency.image}
                      alt={currency.name}
                      className="w-[20px] h-[20px] md:w-7 md:h-7 object-cover"
                    />
                    <span className="text-[10px] text-black dark:text-white md:text-sm font-medium leading-[21px]">
                      {currency.name}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default TokenSelection;
